import { render, staticRenderFns } from "./EditShiftTypeAsUserComponent.vue?vue&type=template&id=dc0af554&scoped=true"
import script from "./EditShiftTypeAsUserComponent.vue?vue&type=script&lang=js"
export * from "./EditShiftTypeAsUserComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0af554",
  null
  
)

export default component.exports